import { GameCommunicationMessageType, IGameCommunicationProcessor } from '@pp/core';
import type { GameStore } from '../../../store/GameStore';
import { mwStateActions } from '../../../store/slices/mwState/slice';

export interface PlayerWinMessage extends GameCommunicationMessageType {
  gId: string;
  mCap: boolean; // Maximum casino payout cap reached
  seq: number; // web socket sequence number
  amt: string; // Number in a string format
}

export class GameCommunicationPlayerWinProcessor implements IGameCommunicationProcessor {
  messageName = 'playerWin';

  process(message: PlayerWinMessage, store: GameStore): void {
    const win = message?.amt ? parseFloat(message.amt) : 0;
    store.dispatch(
      mwStateActions.setWinningAmount({
        winingAmount: win,
      })
    );
  }
}
